import authStyles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import Icon from './../../../image/logo.png';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Header from '../header/index';
import { getFunctions, httpsCallable } from 'firebase/functions';
import DotLoading from './loading';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '../../package/error/index';
import { getApp, getApps, initializeApp } from 'firebase/app';
import Logo from './items/logo';
import DocumentMeta from 'react-document-meta';

// Firebase 初期化はコンポーネント外で
// この静的importはESモジュールの評価順の都合で src/index.js より先に実行され得るため、
// src/index.js と同じ条件分岐(E2E時はEmulator用の固定config)にして、
// どちらが先に initializeApp を呼んでも同一のconfigになるようにしている。
// (config不一致だと2回目の呼び出しで "app/duplicate-app" 例外が発生するため)
const useEmulator = process.env.REACT_APP_USE_EMULATOR === 'true';
const firebaseConfig = useEmulator
  ? {
      apiKey: 'demo-api-key',
      authDomain: 'localhost',
      projectId: 'demo-memorii-e2e',
      storageBucket: 'demo-memorii-e2e.appspot.com',
    }
  : {
      apiKey: process.env.REACT_APP_APIKEY,
      authDomain: process.env.REACT_APP_AUTHDOMAIN,
      databaseURL: process.env.REACT_APP_DATABASEURL,
      projectId: process.env.REACT_APP_PROJECT_ID,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_APP_ID,
      measurementId: process.env.REACT_APP_MEASUREMENT_ID,
    };

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

type LoadingState = "idle" | "loading" | "success" | "error";

const AuthComfirm: React.FC = () => {

  const navigate = useNavigate();
  const auth = getAuth();
  const functions = getFunctions(app, "asia-northeast1");

  const [ errorMessage, setErrorMessage ] = useState("");
  const [ loading, setLoading ] = useState<LoadingState>("idle");
  const [ mail, setMail ] = useState<string>("");

  const [ authComp, setAuthComp ] = useState<boolean>(false);

  // ページロード時にユーザーを監視
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        if (user.emailVerified) {
          setAuthComp(true);
        } else {
          setMail(user.email || '');
        }
      } else {
        setErrorMessage("再度ログインからやり直してください。");
      }
    });

    return () => unsubscribe();
  }, [auth, navigate]);

  // メール再送
  const resendVerificationEmail = async () => {
    setLoading("loading");
    setErrorMessage("");

    if (!mail) {
      setErrorMessage("再度ログインからやり直してください。");
      setLoading("error");
      return;
    }

    try {
      const sendVerificationEmail = httpsCallable(functions, "sendSignupVerificationEmail");
      await sendVerificationEmail({ email: mail });
      alert("確認メールを再送しました！");
      setLoading("success");
    } catch (error: any) {
      setLoading("error");
      setErrorMessage("確認メールの再送に失敗しました。時間を置いて再度お試しください。");
    }
  };

  const meta = {
    title: "認証確認 | memorii works",
    description: "アカウント認証の確認ページです。",
    canonical: "https://memorii-works.com/company/confirm",
    meta: { charset: "utf-8", name: { robots: 'noindex,nofollow,noarchive,noimageindex' } }
  };

  const isWindows = navigator.userAgent.includes("Windows");
  const zoom = isWindows ? 0.8 : 1;

  return (
    <>
    <DocumentMeta {...meta}>
      <div className={authStyles.container}>
        
        <Header />

        <div className={authStyles.main} style={{ zoom }}>

          <div className={authStyles.auth}>


            {errorMessage && <ErrorMessage message={errorMessage} />}

            {authComp ?
              <>
              <div className={authStyles.contents}>
                <p>認証が完了しました。<br />再度ログインからやり直してください。</p>

                <button className={authStyles.contents_btn} onClick={() => navigate('/company/login')} style={{backgroundColor: '#AD0200'}}>
                  ログイン画面へ遷移
                </button>

              </div>
              </>
            :
            <>
              {loading === "loading" && (
                <div className={authStyles.contents}>
                  <DotLoading text="処理中" />
                </div>
              )}

              {(loading === "idle" || loading === "error") && (
                <div className={authStyles.contents}>

                  <div className={authStyles.contents_icon}>
                    <img src={Icon} alt='memorii works' />
                    <h1>memorii works</h1>
                  </div>

                  <h2 className={authStyles.contents_title}>メールアドレス 未認証</h2>

                  <div className={authStyles.contents_message}>
                    <p>ご登録いただいたメールアドレスに届いたURLより<br />本登録を完了してください。</p>
                  </div>

                  <button className={authStyles.contents_btn} onClick={() => resendVerificationEmail()} style={{backgroundColor: '#AD0200'}}>
                    メールを再送信する
                  </button>

                  <p className={authStyles.contents_link} onClick={() => window.location.reload()}>
                    本登録完了済み
                  </p>

                </div>
              )}

              {loading === "success" && (
                <>
                <div className={authStyles.contents}>
                  <p>認証メールを再送信しました。<br />再度ログインからやり直してください。</p>

                  <button className={authStyles.contents_btn} onClick={() => navigate('/company/login')} style={{backgroundColor: '#AD0200'}}>
                    ログイン画面へ遷移
                  </button>
                </div>
                </>
              )}
            </> }

          </div>

          <div className={authStyles.line}></div>

          <div className={authStyles.logo_area}>
            <Logo />
          </div>

        </div>

      </div>
    </DocumentMeta>
    </>
  );
}

export default AuthComfirm;

